module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-video"
  }, [_c('div', {
    on: {
      "~click": function($event) {
        _vm.embed($event)
      }
    }
  }, [_c('div', {
    staticClass: "sky-video-click"
  }, [_c('label', [_c('button', {
    staticClass: "sky-video-play"
  }, [_c('sky-svg', {
    attrs: {
      "name": "play"
    }
  })], 1)])]), _vm._v(" "), (_vm.embedded) ? _c('div', {
    staticClass: "sky-video-iframe"
  }, [_c('iframe', {
    attrs: {
      "frameborder": "0",
      "allowfullscreen": "allowfullscreen",
      "src": _vm.iframeSrc
    }
  })]) : _c('div', {
    staticClass: "sky-video-poster",
    style: (_vm.iframePoster)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-2cf948c8"}!./scripts/sky-video/sky-video.html
// module id = 346
// module chunks = 1